





import { Component, Vue } from 'vue-property-decorator';

import Counter from '@/shared/components/counter/Counter.component.vue';
import { CounterColor } from '@/shared/components/counter/counter.enum.ts';
import { CounterInterface } from '@/shared/components/counter/counter.interface.ts';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Counter,
    ExpansionPanel,
  },
})
export default class PartialCounter extends Vue {
  private counter1: CounterInterface = {
    active: true,
    value: 4,
    title: 'Convocados',
    color: CounterColor.Secondary,
    filter: undefined,
  };
  private counter2: CounterInterface = {
    active: true,
    value: 0,
    title: 'Confirmados',
    color: CounterColor.Primary,
    filter: undefined,
  };
  private counter3: CounterInterface = {
    active: true,
    value: 4,
    title: 'No contesta',
    color: CounterColor.GreyDark,
    filter: undefined,
  };
  private counter4: CounterInterface = {
    active: true,
    value: 2,
    title: 'Bajas',
    color: CounterColor.BlueDark,
    filter: undefined,
  };
}
